import SectionSubhero from './SectionSubhero';
export default SectionSubhero;
